
















import './KisweFormField.scss'
import { defineComponent } from '@vue/composition-api'
import useFlexbox from '../../../compositions/flexbox'

export default defineComponent({
  name: 'KisweFormField',
  props: { ...useFlexbox().props }
})
